import { render, staticRenderFns } from "./PulloutQuestionSwitch.vue?vue&type=template&id=1311ba34&scoped=true&"
import script from "./PulloutQuestionSwitch.vue?vue&type=script&lang=js&"
export * from "./PulloutQuestionSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PulloutQuestionSwitch.vue?vue&type=style&index=0&id=1311ba34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311ba34",
  null
  
)

export default component.exports